import apiClient from '../services/apiClient'

export const getAllUser = async () => {
    return (await apiClient.get('/users')).data
}

export const getUsersByRole = async (role: string, page: number = 1, limit: number = 10) => {
    return (
        await apiClient.get(`/users/role/${role}`, {
            params: { page, limit },
        })
    ).data
}

export const resetPassword = async (pseudo: string) => {
    return await apiClient.post('/users/reset-password', { pseudo }, { params: { role: 'ROLE_ADMIN' } })
}
